import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=05d4cfdf&scoped=true"
import script from "./RequestAccess.vue?vue&type=script&lang=ts"
export * from "./RequestAccess.vue?vue&type=script&lang=ts"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=05d4cfdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4cfdf",
  null
  
)

export default component.exports